import { connect } from 'react-redux'
import intlProviderSelector from './intlProviderSelector'
import IntlProvider from './IntlProvider'

export default connect(
  intlProviderSelector,
  {}
)(IntlProvider)
